import VisitPreview from "./VisitPreview";

export default function VisitsWrapper(props) {
  const { id, verification, visits, setVisits } = props;

  return (
    <>
      <VisitPreview id={id} verification={verification} visits={visits} setVisits={setVisits} />
    </>
  );
}
